import { PositionHolder } from '@/types/approvals'

/** Current holders of a position slot, joined for display. Null when there are none. */
export function holdersLabel(holders?: PositionHolder[]): string | null {
  return holders?.length
    ? holders.map((holder) => holder.name).join(' or ')
    : null
}
